import type { FaireProductEntity } from "../../entity_types/product";

export const p_6nurhxeezp: FaireProductEntity = {
  token: "p_6nurhxeezp",
  type: "product",
  name: "Gameday Polka Dot Puff Sleeve Dress",
  brandToken: "b_q33jfvrznn",
  brandName: "Sewn and Seen",
  imageUrl:
    "https://cdn.faire.com/fastly/087ca9f3706853c37cc9831a24e1c649521f086ea4340984e46255c0e8e262c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48440ef626a57e8ec0ce9d114088b61a7f1b6a32546ce4944ef2806666629d73.jpeg",
    "https://cdn.faire.com/fastly/507878ce20791973407bd7bff98fa2fe776767aa66f24b45c6c6d3d9caa2ec31.jpeg",
    "https://cdn.faire.com/fastly/d48a3767adf73424e8090124ecacebc28238ed7119cfa1175f30ee52e15afa47.jpeg",
    "https://cdn.faire.com/fastly/252b15a2062f5873cd628c53709d99556538dddc6039fdaeb5de39bc8f8306d1.jpeg",
    "https://cdn.faire.com/fastly/18a9aee459f71d2ef9f8136190fa0540addb6ef6872b44d1184498c67c15c2cf.jpeg",
    "https://cdn.faire.com/fastly/10b9e68a092c94ec1488d7ac05af2829f7708df6d0b614914516c8cc64d88d4b.jpeg",
    "https://cdn.faire.com/fastly/b041cfe9b9042456ff0856b856d2f3fde5f9e45aef1d28747cb8fef5b3739d5c.jpeg",
    "https://cdn.faire.com/fastly/089a8544b87552126f5bd389d87246ab0cbe13baecc1affeb9e2ca2e19f6498f.jpeg",
    "https://cdn.faire.com/fastly/53606dfffddbbe5c0157d658be91fe32a739aa32183e7d3b880a8108e2618045.jpeg",
    "https://cdn.faire.com/fastly/2c5f235648f30020c5bc76f8924ffaaca1472110f75a39592d9cfd53bab5f546.jpeg",
    "https://cdn.faire.com/fastly/37331e2870fc5287415d872e8cc89713c1d64bca1109873dd9c4b257dcd25884.jpeg",
    "https://cdn.faire.com/fastly/71188fc0ec5a6855db4960976837a86f01cb9dfba11626d74df7c5799d50750a.jpeg",
    "https://cdn.faire.com/fastly/032c271796f52ee006a1f683b753757567fb84a00ff8bfbd2383a492034da9b5.jpeg",
    "https://cdn.faire.com/fastly/9f29466d5a1f300dce2a6d0313ffdb0f64b15aebf315b82f4e26ce387c5fde57.jpeg",
    "https://cdn.faire.com/fastly/7abedc57bc1787b0fc59ec20b193613ffbe20d7816847c10252be9962009ad0b.jpeg",
    "https://cdn.faire.com/fastly/8010fa1610ac6ab9f8cdd6164a1ac2baac40e7ff89fc1e8736d18f8aa1c316b5.jpeg",
    "https://cdn.faire.com/fastly/a9544338404cd0beec15bb2f6b25520fb0f660db068bb2f7f05ac643c46f7a74.jpeg",
    "https://cdn.faire.com/fastly/9e494310220312ec732c38b8c7ed40df11f14f84c72c1d761df5a1653311167b.jpeg",
    "https://cdn.faire.com/fastly/f620fc46091292c65b1ccf8dcd6a1c85e2abd2827e87c69cb27c1a065f518ca3.jpeg",
    "https://cdn.faire.com/fastly/03228a7b22fc82b00da2d6ece2fc3c5f0c96fff190afa65637a8f07f00952136.jpeg",
    "https://cdn.faire.com/fastly/57e7bcf979eb9a38407d0c7b870a01598ebd0ff01b5216767ec45d9247ec291c.jpeg",
    "https://cdn.faire.com/fastly/ae7aa2144a41901cefba5894d877d10b20934fe1530ad5d32fd78521cc1e7571.jpeg",
    "https://cdn.faire.com/fastly/cc7e9874eb2b13036d8cd2ad38fa32b1d7f8dc5c573ab77068b9b2b05bc0f122.jpeg",
    "https://cdn.faire.com/fastly/07850377750a9e1199479521e18260338fea3070c5413095ca36d1cf58eb9862.jpeg",
    "https://cdn.faire.com/fastly/248ca308307d262477b4f72b3ed06023ca9a696c8acf3d5a74ca865cf4087252.jpeg",
  ],
  priceDollars: 137.7,
  description:
    "This playful polka dot mini dress features a relaxed babydoll silhouette with puff sleeves and a flowy fit for an effortlessly cute look. Designed in a lightweight woven fabric, this easy throw-on style is perfect for gameday events, tailgates, weekend outings, and everyday wear. The bold dot print and relaxed shape make it both comfortable and eye-catching, while the versatile design pairs easily with sneakers or boots. Available in multiple gameday-inspired color combinations as well as classic everyday colorways. gameday dress, polka dot dress, puff sleeve dress, babydoll dress, tailgate outfit, football season outfit, casual mini dress, relaxed fit dress, boutique dress, cute everyday dress, sporty chic, weekend outfit, woven dress, trendy dress, oversized fit dress",
  tags: [],
  msrpDollars: 275.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:59.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
